import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "home py-56"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 col-md-6 col-xl-4 mb-32 mb-xl-0" }
const _hoisted_4 = { class: "professionals-actions" }
const _hoisted_5 = { class: "h4 title text-primary mb-32" }
const _hoisted_6 = { class: "fw-normal" }
const _hoisted_7 = { class: "actions" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-user-add-alt me-12",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-sign-in-circle me-12",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-calendar me-12",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_11 = { class: "col-12 col-md-6 col-xl-4 mb-32 mb-xl-0" }
const _hoisted_12 = { class: "professionals-consultations" }
const _hoisted_13 = { class: "h4 title text-primary mb-32" }
const _hoisted_14 = { class: "fw-normal" }
const _hoisted_15 = { class: "col-12 col-xl-4 mb-32 mb-xl-0" }
const _hoisted_16 = { class: "professionals-patients" }
const _hoisted_17 = { class: "h4 title text-primary mb-32" }
const _hoisted_18 = { class: "fw-normal" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-view-light me-8",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_professional_consultations = _resolveComponent("v-professional-consultations")!
  const _component_v_loader = _resolveComponent("v-loader")!
  const _component_the_professional_home_expedients = _resolveComponent("the-professional-home-expedients")!

  return (_ctx.authUser)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h2", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('Hola,')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.user.name), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                (_ctx.can('professional.expedient.store'))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 0,
                      to: {name: 'professional.expedient.store'},
                      class: "btn btn-primary btn-icon btn-md w-100 mb-8",
                      "aria-label": _ctx.$t('Añadir nuevo paciente')
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('Añadir nuevo paciente')), 1)
                      ]),
                      _: 1
                    }, 8, ["to", "aria-label"]))
                  : _createCommentVNode("", true),
                (_ctx.can('professional.inter-consultation.get-index-by-creator'))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 1,
                      to: {name: 'professional.inter-consultation.get-index-by-creator'},
                      class: "btn btn-primary btn-icon btn-md w-100 mb-8",
                      "aria-label": _ctx.$t('Ver mis interconsultas')
                    }, {
                      default: _withCtx(() => [
                        _hoisted_9,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('Ver mis interconsultas')), 1)
                      ]),
                      _: 1
                    }, 8, ["to", "aria-label"]))
                  : _createCommentVNode("", true),
                (_ctx.can('calendar-event.getIndexByOwner'))
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 2,
                      to: {name: 'professional.calendar'},
                      class: "btn btn-primary btn-icon btn-md w-100 mb-8",
                      "aria-label": _ctx.$t('Modificar mi agenda')
                    }, {
                      default: _withCtx(() => [
                        _hoisted_10,
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('Modificar mi agenda')), 1)
                      ]),
                      _: 1
                    }, 8, ["to", "aria-label"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h2", _hoisted_13, [
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t('Últimas')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('consultas')), 1)
              ]),
              (_ctx.status === 'loaded')
                ? (_openBlock(), _createBlock(_component_v_professional_consultations, {
                    key: 0,
                    class: "py-12 px-8",
                    consultations: _ctx.consultations,
                    "show-patient": true,
                    "allow-create": false
                  }, null, 8, ["consultations"]))
                : (_openBlock(), _createBlock(_component_v_loader, { key: 1 }))
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h2", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('Listado de')), 1),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('pacientes')), 1)
              ]),
              _createVNode(_component_the_professional_home_expedients, { class: "py-12 px-8 mb-24" }),
              (_ctx.can('professional.expedient.index'))
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: {name: 'professional.expedient.index'},
                    class: "btn btn-secondary btn-icon btn-sm mb-8",
                    "aria-label": _ctx.$t('Ver todos los pacientes')
                  }, {
                    default: _withCtx(() => [
                      _hoisted_19,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('Ver todos los pacientes')), 1)
                    ]),
                    _: 1
                  }, 8, ["to", "aria-label"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}